import { render, staticRenderFns } from "./M3.vue?vue&type=template&id=3401a1dd"
import script from "./M3.vue?vue&type=script&lang=js"
export * from "./M3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports